<template>
  <div>
    <!--  buttons -->
    <div class="button-mode">
      <div>
        <el-checkbox
            v-if="isCardList && socialPosts.list.length > 0"
            class="mt-2"
            v-model="selectAll"
            @change="toggleAll"
        > {{ !selectAll ? $t('posts.card.selectAll') : $t('posts.card.deSelectAll') }}
        </el-checkbox>
      </div>
      <div>
        <el-button size="mini" v-if="isCardList" @click="setView('list')"><em class="el-icon-s-fold"></em>{{$t("users.listMode") }}</el-button>
        <el-button size="mini" v-if="isListView" @click="setView('sticker')"><em class="el-icon-menu"></em>{{$t("users.vignetteMode") }}</el-button>
      </div>
    </div>
    <!--  cards -->
    <div v-if="isCardList && socialPosts.list.length > 0">
      <div class="cards-wrapper" v-loading="loadingStatus" :element-loading-text="$t('portals.list.chargementDonnees')">
        <div v-for="result in socialPosts.list" :key="result.id">
          <div class="card">
            <div class="card-header">
              <el-checkbox
                  class="checkbox-card"
                  :value="localSelected.includes(result)"
                  @change="value => toggleCard(result, value)"
              ></el-checkbox>
              <img v-if="result.photoPrincipale" :src="result.photoPrincipale.url" :srcset="result.photoPrincipale.url" class="card-image"/>
              <ubi-icon v-else-if="type === 'Editoriaux'" name="video-camera" size='180'/>
              <ubi-icon v-else class="no-photo" name="camera" size='180'/>
            </div>
            <div class="card-body">
              <div class="card-left">
                <p><span class="subtitle">{{$t('posts.card.reference')}}:</span> {{ result.reference }} </p>
                <p><span class="subtitle">{{$t('posts.card.title')}}:</span> {{ capitalizeFirstLetter(result.titre) }} </p>
                <div class="component-icons-and-date">
                  <social-posts-list-table-presence-icons :post="result" :noDash="true"></social-posts-list-table-presence-icons>
                  <social-posts-list-table-presence :post="result" :noDash="true"></social-posts-list-table-presence>
                </div>
              </div>
              <div class="card-right">
                <div>
                  <em class="el-icon-edit-outline" :alt="$t('posts.edit.edit')" @click="editPost(result.id)" style="margin-right: 10px;"></em>
                  <em class="el-icon-delete" :alt="$t('posts.edit.remove')" v-if="checkNbDiffusionsActives(result) > 0" @click="deleteModalShow(result)"></em>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isCardList && socialPosts.list.length === 0">{{ $t('posts.card.noData')}}</div>
  </div>
</template>

<script>
import SocialPostsListTablePresenceIcons from '@/pages/socialNetworks/Blocks/SocialPostsListTablePresenceIcons.vue'
import SocialPostsListTablePresence from '@/pages/socialNetworks/Blocks/SocialPostsListTablePresence.vue'
import { mapGetters, mapMutations } from 'vuex'
import { capitalizeFirstLetter } from '../../helpers/capitalized'
import UbiIcon from "@/components/Icon.vue";

export default {
  name: 'SocialPostCard',
  components: {
    UbiIcon,
    SocialPostsListTablePresenceIcons,
    SocialPostsListTablePresence
  },
  props: {
    loadingStatus: {
      type: Boolean,
      required: true
    },
    socialPosts: {
      type: Object,
      required: true
    },
    selected: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      localSelected: [],
      selectAll: false
    }
  },
  watch: {
    localSelected (newValue) {
      this.$emit('update:selected', newValue)
    }
  },
  computed: {
    ...mapGetters('socialNetworkPosts', ['getView', 'isListView', 'isCardList'])
  },
  methods: {
    capitalizeFirstLetter,
    ...mapMutations('socialNetworkPosts', ['setView']),
    checkNbDiffusionsActives (post) {
      let nbEnvoyees = 0
      let found = 0

      if (post.diffusions && post.diffusions.length > 0) {
        post.diffusions.forEach(function (element) {
          if (element.firstSentAt === null) {
            nbEnvoyees = nbEnvoyees + 1
          } else {
            found = 1
          }
        })
      }
      if (found === 1) {
        nbEnvoyees = 0
      }
      if (post.diffusions.length === 0 && post.planifications) {
        nbEnvoyees = 1
      }
      if (!post.planifications) {
        nbEnvoyees = 0
      }
      return nbEnvoyees
    },
    deleteModalShow (post) {
      this.$store.commit('socialPostsTableAnnonces/setModalDelete', true)
      this.$store.commit('socialPostsTableAnnonces/setPostToDelete', [post])
    },
    editPost (id) {
      if(this.type === 'Annonces') {
        this.$router.push({ name: 'manage-posts', params: { id: id } })
      } else if(this.type === 'BiensVendus') {
        this.$router.push({ name: 'manage-posts', params: { id: id } })
      } else if(this.type === 'Editoriaux') {
        this.$router.push({ name: 'edit-post-editorial', params: { id: id } })
      }
    },
    toggleCard (card, isChecked) {
      if (isChecked) {
        if (!this.localSelected.includes(card)) {
          this.localSelected.push(card)
        }
      } else {
        this.localSelected = this.localSelected.filter(s => s !== card)
      }
    },
    toggleAll (isChecked) {
      if (isChecked) {
        this.localSelected = this.socialPosts.list.map(item => item)
      } else {
        this.localSelected = []
      }
    }
  },
  mounted () {
    this.localSelected = [...this.selected]
  }
}
</script>

<style lang="css" scoped>
em.el-icon-delete:hover {
  color: #d24554 !important;
  font-weight: bold;
  cursor: pointer;
}

em.el-icon-edit-outline:hover {
  color: #00a4bd !important;
  font-weight: bold;
  cursor: pointer;
}

.button-mode {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  width: 100%;
  -webkit-box-align: center;
  -webkit-align-items: center;
}

.cards-wrapper {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
}

.card {
  width: 480px;
  height: 400px;
  border: 1px solid #ccc;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  background-color: #fff;
}

.card-header {
  position: relative;
  width: 100%;
  height: 200px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  background: #FFEFDF;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  overflow: hidden;
}

.card-header img {
  -webkit-object-fit: contain;
  object-fit: contain;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.card-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-object-fit: cover;
  object-fit: cover;
  -webkit-transform: none;
  transform: none;
}

.card-body {
  max-height: 400px;
  padding: 15px;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  flex-grow: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}

.card-left {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
  margin-right: 15px;
}

.card-right {
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  margin-top: 8px;
}

.card-left p,
.card-right p {
  margin: 5px 0;
  color: #000;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.subtitle {
  color: #184a56;
  line-height: 1.5;
  font-weight: 700;
  display: inline-block;
}

.component-icons-and-date {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  align-items: flex-end;
  gap: 10px;
  margin-top: 10px;
}

.checkbox-card {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
}
</style>
